import { render, staticRenderFns } from "./OrdersModal.vue?vue&type=template&id=39e92aff&scoped=true&"
import script from "./OrdersModal.vue?vue&type=script&lang=js&"
export * from "./OrdersModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersModal.vue?vue&type=style&index=0&id=39e92aff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e92aff",
  null
  
)

export default component.exports